/**
 * Pemulihan otomatis ChunkLoadError pasca-deploy.
 *
 * Browser yang memegang page lama (pra-deploy) meminta chunk lama; setelah
 * deploy, module registry di chunk berubah → webpack melempar ChunkLoadError
 * ("Failed to load chunk ... from module N"). Hard reload memuat HTML + chunk
 * fresh dan memulihkan halaman tanpa user perlu berbuat apa-apa.
 *
 * Auto-reload DIBATASI sekali per 60 detik (sessionStorage) — chunk yang
 * benar-benar rusak tidak boleh berubah menjadi loop reload tak terbatas.
 */
const RELOAD_GUARD_KEY = "chunk-reload-at";

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return (
    error.name === "ChunkLoadError" ||
    /failed to load chunk|loading chunk \d|chunkloaderror/i.test(error.message)
  );
}

/** Return true bila reload dipicu (pemanggil boleh skip render fallback). */
export function reloadOnChunkLoadError(error: unknown): boolean {
  if (!isChunkLoadError(error)) return false;
  const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) ?? 0);
  if (Date.now() - last < 60_000) return false;
  sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
  window.location.reload();
  return true;
}
